/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */


app.controller('dialog_acceptUserSchichtCtrl', ['$rootScope','$scope', '$http', 'NetworkService', 'MainService', function ($rootScope, $scope, $http, NetworkService, MainService) {

        $scope.acceptUserSchicht = function ()
        {
            data = MainService.getDialogData("dialog_acceptUserSchichtCtrl")

            var email = data.email
            var schicht_id = data.schicht_id
            var position_id = data.position_id
            var eingesetzt_als = $scope.eingesetzt_als
            NetworkService.acceptUserSchicht(email, schicht_id, position_id, eingesetzt_als, function(){
                $rootScope.$emit("repaint")
            })
        }
        
        $scope.setEingesetztAls = function(eingesetzt_als)
        {
            $scope.eingesetzt_als = eingesetzt_als
        }
        
        NetworkService.getEingesetztAls(function(data)
        {
            $scope.suggests = data.data
        })
    }])